import { toRefs, provide, computed } from 'vue';
import { useModel } from '../../compositions/component-lib.esm13.js';

//

/**
 * The required parent element of `<TabBar>` and `<TabPanel>`.
 */
var script = {
  name: 'Tabs',
  props: {
    value: {
      type: String,
      required: true
    },
    fixedTabs: Boolean,
    /**
     * If true, the content of the tab will be rendered immediately.
     */
    alwaysRenderTabContent: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      fixedTabs,
      alwaysRenderTabContent
    } = toRefs(props);
    const localValue = useModel(value, val => emit('input', val));
    provide('tabs', {
      selectedTab: localValue,
      alwaysRenderTabContent
    });
    const classes = computed(() => {
      return {
        'v-tabs--fixed': fixedTabs.value
      };
    });
    return {
      classes
    };
  }
};
export { script as default };